import React from 'react';
import './loadingCircle.css';

const LoadingCircle = () => {
  return (
    <>
    <div>
    <p>Loading</p>
    <div className="loader"></div>
    </div>
    </>
  );
};

export default LoadingCircle;
